import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import AppiService from '../../services/ApiService';

const Navbar = () => {
  useLocation();
  const [open, setOpen] = useState(false);

  const isAuthenticated = AppiService.isAuthenticated();
  const isAdmin = AppiService.isAdmin();
  const isCustomer = AppiService.isCustomer();
  const isPilot = AppiService.isPilot();

  const navigate = useNavigate();

  const handleLogout = () => {
    const isLogout = window.confirm('Are you sure you want to logout?');
    if (isLogout) {
      AppiService.logout();
      navigate('/login');
      setOpen(false);
    }
  };

  const closeMenu = () => setOpen(false);

  return (
    <nav className="nb">
      <div className="nb-container">
        <div className="nb-brand">
          <Link to="/" className="ng-logo" onClick={closeMenu}>
            <span className="logo-airline">Daniel</span>
            <span className="logo-text">Airlines</span>
          </Link>
        </div>

        <button className="nb-toggle" onClick={() => setOpen((v) => !v)} aria-label="Toggle menu">
          ☰
        </button>

        <div className={`nb-links ${open ? 'is-open' : ''}`}>
          <Link to="/home" className="nav-link" onClick={closeMenu}>
            Home
          </Link>
          <Link to="/flights" className="nav-link" onClick={closeMenu}>
            Find Flights
          </Link>

          {isAuthenticated ? (
            <>
              {isCustomer && (
                <Link to="/profile" className="nav-link" onClick={closeMenu}>
                  Profile
                </Link>
              )}
              {isPilot && (
                <Link to="/pilot" className="nav-link" onClick={closeMenu}>
                  Pilot
                </Link>
              )}
              {isAdmin && (
                <Link to="/admin" className="nav-link" onClick={closeMenu}>
                  Admin
                </Link>
              )}

              <button className="nav-button" onClick={handleLogout}>
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="nav-link" onClick={closeMenu}>
                Login
              </Link>
              <Link to="/register" className="nav-button nav-button-primary" onClick={closeMenu}>
                Sign Up
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
